export default "__VITE_ASSET__bgkGpqYt__"